import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { LangProvider } from './lib/lang'
import { HomePage } from './pages/HomePage'
import { AdminApp } from './pages/admin/AdminApp'

export function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  )
}
